import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { useInquiries } from '@/features/faq/inquries/hooks/useInquiries';
import { InquriesTable } from '@/features/faq/inquries/table';
import { Translation } from '@/hoslog-intl';
import { SmsIcon } from '@/icons';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['inquiryId', 'nickName', 'email', 'phoneNumber', 'inquiryType', 'message', 'createdDate']),
  desc: z.boolean(),
});

const inquirySearchSchema = z
  .object({
    sort: z
      .preprocess((val) => {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch {
            return undefined;
          }
        }
        return val;
      }, z.array(sortItemSchema))
      .optional(),

    createdDate: z.string().optional(),
    q: z
      .any()
      .optional()
      .transform((val) => (val == null ? undefined : String(val))),

    page: z.coerce.number().positive().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(10),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/faq/inquiry/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="faq.inquiry.crumb" icon={SmsIcon} />,
      title: <Translation id="faq.inquiry.title" />,
    };
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => inquirySearchSchema.parse(search),
});

function RouteComponent() {
  const { inquiries, pagination, loading } = useInquiries();
  return <InquriesTable data={inquiries} pagination={pagination} loading={loading} />;
}
